import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import PaymentButtons from '../PayamentsButton/PaymentsButtonList';
import Subscription from '../SubscriptionButtonV2/SubscriptionButtonList';

type Props = {
  location: {
    pathname: string
  },
};

const Buttons = (props: Props) => {
  const {
    location,
  } = props;
  const [current, setCurrent] = useState('buttons');

  const setMenu = (query) => {
    switch (query) {
      case '/pay-links/payment-buttons': {
        setCurrent('buttons');
        break;
      }
      case '/pay-links/subscription-button': {
        setCurrent('subscription');
        break;
      }
      default:
        setCurrent('buttons');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="buttons">
          <SpTab
            to="/pay-links/payment-buttons"
            selected={current === 'buttons'}
            fontSize="14px"
          >
            Payment Buttons
          </SpTab>
        </Menu.Item>
        <Menu.Item key="subscription">
          <SpTab
            to="/pay-links/subscription-button"
            selected={current === 'subscription'}
            fontSize="14px"
          >
            Subscription Buttons
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/pay-links/payment-buttons" component={PaymentButtons} />
        <Route exact path="/pay-links/subscription-button" component={Subscription} />
      </Switch>
    </div>
  );
};

export default withRouter(Buttons);
